



















































import { Component, Vue, Prop } from 'vue-property-decorator'
import { IRekordcloudUserProps } from '../store/modules/auth'

const STORAGE_KEY_PREFIX: string = 'TUTORIAL_CLOSED_'

export interface ITutorialSlide {
  image?: string
  html: string
}

@Component({
  components: {
    TitleLine: require('@/components/TitleLine').default,
    Tip: require('@/components/Tip').default
  }
})
export default class Tutorial extends Vue {
  @Prop({
    required: true
  })
  storageKey: string

  @Prop({
    required: true
  })
  slides: ITutorialSlide[]

  @Prop({
    required: true
  })
  name: string

  @Prop()
  wikiLink: string

  hidden: boolean = true

  isLastSlide: boolean = this.slides.length === 1
  isFirstSlide: boolean = true

  get isDemoUser(): boolean {
    return this.$store.state.auth.isDemoUser
  }

  get userProps(): IRekordcloudUserProps {
    return this.$store.state.auth.userProps
  }

  get tutorialsDisabled(): boolean {
    return this.userProps && this.userProps.uiPreferences && this.userProps.uiPreferences.tutorialsDisabled
  }

  onChange(i: number) {
    this.isLastSlide = i === this.slides.length - 1
    this.isFirstSlide = i === 0
  }

  show() {
    this.hidden = false
    this.isLastSlide = this.slides.length === 1
    this.isFirstSlide = true
  }

  hide() {
    this.hidden = true

    if (this.storageKey && !this.isDemoUser) {
      localStorage.setItem(STORAGE_KEY_PREFIX + this.storageKey, '1')
    }
  }

  previous() {
    (this.$refs as any).carousel.prev()
  }

  next() {
    if (this.isLastSlide) {
      this.hide()
    } else {
      (this.$refs as any).carousel.next()
    }
  }

  created() {
    const userAlreadyClosed = localStorage.getItem(STORAGE_KEY_PREFIX + this.storageKey)

    if (!userAlreadyClosed && !this.tutorialsDisabled) {
      setTimeout(() => {
        this.show()
      }, 100)
    }
  }
}
